import { RequestProfileWidgetKey } from '../RequestProfileWidget.constants'

export const REQUEST_PROFILE_WIDGET_LIST_PAGE = 'request-detail'

export const REQUEST_PROFILE_DEFAULT_WIDGET_LIST_ORDER = [
  RequestProfileWidgetKey.AI_SUMMARY,
  RequestProfileWidgetKey.LABELS,
  RequestProfileWidgetKey.PROVIDERS,
  RequestProfileWidgetKey.SIDE_WORKERS,
  RequestProfileWidgetKey.ASSIGNEES,
  RequestProfileWidgetKey.CREATED,
  RequestProfileWidgetKey.FINISHED,
  RequestProfileWidgetKey.BUDGET_PLAN,
  RequestProfileWidgetKey.ADDRESS,
  RequestProfileWidgetKey.INHABITANTS,
  RequestProfileWidgetKey.BUILDING_GROUPS,
  RequestProfileWidgetKey.TIME_TRACKING,
]
